import { CoreDataSecurityApplicationsByIdName } from './name';
import { getCoreDataSecurityAppUsersSlice } from '@slice/data-security/app-users/get';
import { patchDataSecurityApplicationById } from '@api/data-security';
import { updateApplicationReferences } from '../_idMap/actions';
import { updateCoreDataSecurityApplicationSyncSlice } from '../update';

import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createPatchAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const patchCoreDataSecurityApplicationByIdSlice = createPatchAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.APPLICATION_MODIFIED, (action) => action.data),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) => updateApplicationReferences([ request ]),
			(request) => updateCoreDataSecurityApplicationSyncSlice.syncActionCreator(request),
			() => getCoreDataSecurityAppUsersSlice.asyncActionCreators.requestGetCoreDataSecurityAppUsers({ filter: '' })
		]
	},
	name: CoreDataSecurityApplicationsByIdName,
	receive: false,
	request: true,
	requestHandler: patchDataSecurityApplicationById
});
